import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-toastify";
import "./UsuarioForm.css";

export default function UsuarioForm() {
  const { currentUser, token } = useAuth();
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchUsuarios = async () => {
  try {
    const res = await fetch("/api/usuarios", {
      headers: { Authorization: `Bearer ${token}` },
    });

    console.log("Resposta bruta:", res);

    if (!res.ok) {
      const text = await res.text(); // pega a resposta mesmo se for HTML
      console.warn("Resposta não OK:", text);
      throw new Error("Erro na requisição: " + res.status);
    }

    const data = await res.json(); // vai dar erro se a resposta não for JSON
    setUsuarios(data);
  } catch (err) {
    toast.error("Erro ao carregar usuários: " + err.message);
  } finally {
    setLoading(false);
  }
};


  const handleChangeStatus = async (u) => {
    try {
      const novoStatus = u.status === "ativo" ? "inativo" : "ativo";
      const res = await fetch(`/api/usuarios/${u.id}/status`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify({ status: novoStatus }),
      });
      if (!res.ok) throw new Error(await res.text());
      toast.success("Status atualizado!");
      fetchUsuarios();
    } catch (err) {
      toast.error("Erro ao alterar status: " + err.message);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Deseja excluir este usuário?")) return;
    try {
      const res = await fetch(`/api/usuarios/${id}`, {
        method: "DELETE",
        headers: { "Authorization": `Bearer ${token}` },
      });
      if (!res.ok) throw new Error(await res.text());
      toast.success("Usuário excluído!");
      fetchUsuarios();
    } catch (err) {
      toast.error("Erro ao excluir usuário: " + err.message);
    }
  };

  useEffect(() => {
    if (currentUser?.isAdmin) fetchUsuarios();
    else setLoading(false);
  }, [currentUser]);

  if (!currentUser) {
    return <p>⏳ Carregando dados do usuário...</p>;
  }

  if (!currentUser.isAdmin) {
    return (
      <div className="usuario-form">
        <h3>❌ Acesso restrito</h3>
        <p>Somente administradores têm permissão para gerir usuários.</p>
         <p>Peça permissão ao administrador do sistema.</p>
      </div>
    );
  }

  return (
    <div className="usuario-form">
      <h3>Gerenciamento de Usuários</h3>
      {loading ? (
        <p>Carregando usuários...</p>
      ) : (
        <table className="user-table">
          <thead>
            <tr>
              <th>ID</th><th>Nome</th><th>Email</th><th>Status</th><th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {usuarios.map(u => (
              <tr key={u.id}>
                <td>{u.id}</td>
                <td>{u.username}</td>
                <td>{u.email}</td>
                <td>{u.status}</td>
                <td>
                  <button onClick={() => handleChangeStatus(u)}>
                    {u.status === "ativo" ? "Desativar" : "Ativar"}
                  </button>
                  {" "}
                  <button onClick={() => handleDelete(u.id)}>Excluir</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
